import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const { deleteManager } = config.endpoints

const deleteMessage = (data) => axios({
  method: 'post',
  url: deleteManager.deleteMessage,
  data,
  headers: getHeaders(true)
})


const deleteComment = (data) => axios({
  method: 'post',
  url: deleteManager.deleteComment,
  data,
  headers: getHeaders(true)
})

const deleteSubject = (data) => axios({
  method: 'post',
  url: deleteManager.deleteSubject,
  data,
  headers: getHeaders(true)
})

const deleteConversation = (data) => axios({
  method: 'post',
  url: deleteManager.deleteConversation,
  data,
  headers: getHeaders(true)
})

export default {
  deleteMessage,
  deleteComment,
  deleteSubject,
  deleteConversation
}